/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Error_ } from "./Error_";
export const Errors = core.serialization.object({
    errors: core.serialization.list(Error_),
});
